<template>
  <div class="opponent-leaderboard">
    <div class="content">
      <div class="opponent" :style="{backgroundImage: `url(${opponent.image6})`}">
        <div class="my-highscore" v-if="myHighscore">
          <BaseText4 class="label" text="Your rank"/>
          <BaseText3 :text="myHighscore.index + 1"/>
          <img class="c" src="@/assets/img/champion-c-2.svg">
          <BaseText4 class="label" text="Score"/>
          <BaseText3 :text="myHighscore.score"/>
        </div>
        <BaseText11 class="opponent-name" :text="opponent.firstName + '<br>' + opponent.lastName"/>
      </div>
      <div class="highscores first">
        <ScoreRow
          v-for="(item, i) in highscoresFirst"
          :key="i"
          :rank="item.rank"
          :name="item.name"
          :surname="item.surname"
          :score="item.score"
          :body-background-color="i % 2 === 0 ? 'var(--color-gray-7)' : 'var(--color-gray-2)'"
          :rank-background-color="i % 2 === 0 ? 'var(--color-white-1)' : 'var(--color-gray-6)'"
        />
      </div>
      <div class="highscores second">
        <ScoreRow
          v-for="(item, i) in highscoresSecond"
          :key="i"
          :rank="item.rank"
          :name="item.name"
          :surname="item.surname"
          :score="item.score"
          :body-background-color="i % 2 === 0 ? 'var(--color-gray-7)' : 'var(--color-gray-2)'"
          :rank-background-color="i % 2 === 0 ? 'var(--color-white-1)' : 'var(--color-gray-6)'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ScoreRow from './partials/ScoreRow/ScoreRow'
import LeaderboardService from '@/services/LeaderboardService'
import BaseText3 from '@/components/BaseText3/BaseText3'
import BaseText4 from '@/components/BaseText4/BaseText4'
import BaseText11 from '@/components/BaseText11/BaseText11'
import { opponentsById } from '@/data/opponents'
import { mapState } from 'vuex'
export default {
  components: {
    ScoreRow,
    BaseText3,
    BaseText4,
    BaseText11
  },
  props: {
    opponentId: {
      type: String,
      required: true
    }
  },
  data: () => ({
    myHighscore: null,
    highscores: []
  }),
  computed: {
    ...mapState('user', {
      userId: state => state.userProfile._id
    }),
    opponent () {
      return opponentsById[this.opponentId]
    },
    highscoresFirst () {
      return this.highscores.slice(0, 12)
    },
    highscoresSecond () {
      return this.highscores.slice(12, 24)
    }
  },
  methods: {
    async fetchData () {
      if (this.myHighscore && this.highscores.length) return
      [this.myHighscore, this.highscores] = await Promise.all([
        this.userId && LeaderboardService.getMyHighscore({ userId: this.userId, opponentId: this.opponentId }),
        LeaderboardService.getAllHighscores({ opponentId: this.opponentId, limit: 50 })
      ])
      this.highscores.map((item, i) => (item.rank = i + 1))
    }
  }
}
</script>

<style lang="scss" scoped>
.opponent-leaderboard {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: calc(var(--spacing-1) + 1rem);
}
.content {
  width: 100%;
  height: 100%;
  display: flex;
  max-width: 80rem;
  max-height: 40rem;
  > *:not(:last-child) {
    margin-right: var(--spacing-3);
  }
}
.opponent {
  position: relative;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
}
.my-highscore {
  background: var(--color-gold-1);
  padding: var(--spacing-2) 3rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  > *:not(:last-child) {
    margin-bottom: 0.6rem;
  }
}
.c {
  height: 4rem;
}
.label {
  margin-bottom: 0.5rem !important;
}
.opponent-name {
  text-align: left;
  margin: var(--spacing-1);
  font-size: 3rem;
  margin-top: auto;
}
.highscores {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  > * {
    height: calc(100% / 12);
  }
}
</style>
